import { createRouter, createWebHistory } from 'vue-router';
import admin from './modules/admin';
import PermissionDenied from '@/views/auth/permissionDenied.vue';
import { useGlobalStore } from '@/store/global';
import { clearForLogout } from '@/utils/auth';
import NotFound from '@/components/elements/notFound.vue';


const authMiddleware = () => {
  const token = localStorage.getItem("access_token");
  return !!token;
};


const routes = [
  {
    path: "/",
    name: "Main",
    redirect: { name: "AdminDashboard" },
    component: () => import("@/layouts/MainLayout"),
    children: admin,
    meta: { requiresAuth: true }, // 🔥 Auth tekshiruvi qo‘shildi
  },
  {
    path: "/",
    name: "Empty",
    component: () => import("@/layouts/EmptyLayout"),
    children: [
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/auth/Login.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/user-notfound",
        name: "Usernotfound",
        meta: { requiresAuth: false },
        component: () => import("@/views/auth/userNotFound.vue"),
      },
      {
        path: "/no-permission",
        name: "PermissionDenied",
        component: PermissionDenied,
      },
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
];

// **Router yaratish**
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (!to.meta['savePosition']) {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    const globalStore = useGlobalStore();
    let permission = await globalStore.can("stat2.it-park.uz", "*");

    if (!authMiddleware() || !permission) {
      clearForLogout();
      return { name: "Login", query: { redirect: to.fullPath } };
    }
  }
});

export default router;
